import React, { ReactNode, useEffect, memo } from 'react';
import { IntercomProviderProps } from 'react-use-intercom/src/types';
import { IntercomProvider } from 'react-use-intercom';
import { environment } from '../enviroments';
import { useAuthFlow, useLog } from 'src/shared';
import useIntercomPlugin from 'src/shared/hooks/useIntercomPlugin';

type IntercomPluginProviderType = {
  children: ReactNode;
} & Pick<IntercomProviderProps, 'appId'>;

export const IntercomAuthBridge = memo(() => {
  const { authUser } = useAuthFlow();
  const { logError } = useLog();
  const { registerUser, clearUser } = useIntercomPlugin();

  useEffect(() => {
    (async () => {
      try {
        if (authUser?.uid) {
          await registerUser({ userId: authUser.uid, email: authUser.email ?? undefined });
        }
      } catch (error) {
        logError(error, {
          action: 'IntercomAuthBridge',
        });
      }
    })();
  }, [authUser?.uid, authUser?.email, registerUser, clearUser]);

  return null;
});

export const IntercomPluginProvider: React.FC<IntercomPluginProviderType> = ({ children }): JSX.Element => {
  return (
    <IntercomProvider appId={environment.INTERCOM.APP_ID}>
      <IntercomAuthBridge />
      {children}
    </IntercomProvider>
  );
};
